'use strict';

import setModalVideo from "../../../frontend/js/video-modal";

class CampaignCardVideoPlayer {
    constructor(playButtons) {
        this.init(playButtons);
    }

    init(playButtons) {
        playButtons.forEach(playButton => {
            const campaignCard = playButton.closest('.campaign-card-video');
            if (campaignCard) {
                this.attachClickHandler(campaignCard);
            }
        });
    }

    attachClickHandler(campaignCard) {
        campaignCard.addEventListener('pointerup', (event) => {
            if (event.which !== 1)
                return;

            const videoUrl = `https://www.youtube.com/embed/${campaignCard.dataset.videoUrl}?autoplay=1&mute=1`;
            const videoHost = 'youtube';
            setModalVideo({ videoHost, videoUrl });
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const playButtons = document.querySelectorAll('.campaign-card-with-video__play');
    if (playButtons) {
        new CampaignCardVideoPlayer(playButtons);
    }
});